import { min, max, parseISO, format, startOfDay, endOfDay, formatISO } from 'date-fns'
import {
  Availabilities, 
  Availability, 
  AvailabilityResponse, 
  FormattedAvailability, 
  FormattedAvailabilityResponse 
} from './types'

export function getMinAndMaxDatesFromDateList(dateArray: string[]): FormattedAvailability {
  const dateArrayAsDateObjects = dateArray.map(dateString => parseISO(dateString))
  const startDate = min(dateArrayAsDateObjects)
  const endDate = max(dateArrayAsDateObjects)
  
  return { 
    startDate: formatISO(startOfDay(startDate)),
    endDate: formatISO(endOfDay(endDate)),
  }
}

export function formatAvailabilityResponse(response: AvailabilityResponse): FormattedAvailabilityResponse {
  const formattedResponse: FormattedAvailabilityResponse = {
    availabilities: {}
  }

  Object.keys(response.availabilities).forEach(date => {
    const availabilities: Availability[] = response.availabilities[date]
    formattedResponse.availabilities[date] = availabilities.map(availability => {
      return {
        startDate: availability.start_date,
        endDate: availability.end_date
      }
    })
  })

  return formattedResponse
}

export function getDaysWithEvents(events: Availabilities, days: string[]): Availabilities {
  const result: Availabilities = {}
  for (const day of days) {
    if (Object.prototype.hasOwnProperty.call(events, day)) {
      result[day] = events[day]
    }
  }
  return result
}

export function formatEvents(daysWithEvents: Availabilities): Availabilities[] {
  const formattedEvents = []

  for (const day in daysWithEvents) {
    const events = daysWithEvents[day]
    const formattedDay = {}

    if (events.length > 0) {
      formattedDay[day] = events
        .filter(event => {
          const eventDate = new Date(event.startDate)
          eventDate.setHours(23)
          return eventDate.toISOString()
        })
        .map(event => format(new Date(event.startDate), 'yyyy-MM-dd\'T\'HH:mm:ss'))
    } else {
      formattedDay[day] = []
    }

    formattedEvents.push(formattedDay)
  }

  return formattedEvents
}